export const PDF_DELIVERY_MODE = "preview_tab";
export const PDF_POPUP_BLOCKED_FALLBACK = "download";

const PREVIEW_MODE = "preview_tab";
const DOWNLOAD_MODE = "download";
const BLOB_URL_REVOKE_DELAY_MS = 60000;

const createPdfObjectUrl = (doc, fileName) => {
  const pdfBlob = doc.output("blob");

  if (typeof File !== "undefined") {
    try {
      const pdfFile = new File([pdfBlob], fileName, { type: "application/pdf" });
      return URL.createObjectURL(pdfFile);
    } catch (error) {
      // If File is not supported, fallback to Blob URL.
    }
  }

  return URL.createObjectURL(pdfBlob);
};

const downloadBlobUrl = (blobUrl, fileName) => {
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const isBrowser = () => typeof window !== "undefined" && typeof document !== "undefined";

const openNewTab = (url = "") => {
  const tab = window.open(url, "_blank");
  if (tab) {
    try {
      tab.opener = null;
    } catch (error) {
      // Ignore opener hardening errors and continue.
    }
  }
  return tab;
};

export const reservePdfTarget = () => {
  if (!isBrowser() || PDF_DELIVERY_MODE !== PREVIEW_MODE) return null;

  try {
    return openNewTab("");
  } catch (error) {
    return null;
  }
};

export const deliverPdf = ({ doc, fileName, targetWindow = null }) => {
  if (!doc || !fileName) return false;

  if (!isBrowser() || PDF_DELIVERY_MODE === DOWNLOAD_MODE) {
    doc.save(fileName);
    return true;
  }

  const pdfUrl = createPdfObjectUrl(doc, fileName);

  let previewOpened = false;

  if (targetWindow && !targetWindow.closed) {
    try {
      targetWindow.location.href = pdfUrl;
      previewOpened = true;
    } catch (error) {
      previewOpened = false;
    }
  }

  if (!previewOpened) {
    try {
      const newTab = openNewTab(pdfUrl);
      previewOpened = Boolean(newTab);
    } catch (error) {
      previewOpened = false;
    }
  }

  if (!previewOpened && PDF_POPUP_BLOCKED_FALLBACK === DOWNLOAD_MODE) {
    downloadBlobUrl(pdfUrl, fileName);
  }

  setTimeout(() => URL.revokeObjectURL(pdfUrl), BLOB_URL_REVOKE_DELAY_MS);
  return previewOpened;
};
